const system = {
  fonts: {
    heading: '"TamanegiKaishoGeki", "Kaisei Decol", serif',
    body: '"Noto Serif JP", serif',
    latin: '"Cormorant Infant", serif',
  },
  fontSizes: { small: "12px", medium: "16px", large: "24px" },
  colors: {
    text: { primary: "#ffffff", secondary: "#c8c8c8", warning: "#ff383c" },
    background: { card: "rgba(8, 8, 8, 0.82)", dialog: "rgba(20, 20, 20, 0.98)" },
    accent: { red: "#bf2120", deepRed: "#750009", black: "#111111" },
  },
};

export default system;
